import React, { useState } from "react";
import { AppShell } from "@mantine/core";
import { AppHeader } from "../Components/app-header/AppHeader";
import { AppSideBar } from "../Components/app-side-bar/AppSideBar";
import { useAuth } from "../Context/useAuth";
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

interface CommonAppShellProps {
  sidebarLabel: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  padding?: string | number;
  isSidebar?: boolean;
}

const CommonAppShell: React.FC<CommonAppShellProps> = ({ sidebarLabel, children, style, padding, isSidebar }) => {
  const { user } = useAuth();
  const [currentConsentData, setCurrentConsentData] = useState<any | null>(null);
  const [opened, { toggle }] = useDisclosure();
  const { t } = useTranslation();

  const handleActiveConsentData = (consentData: any) => {
    console.log('[CommonAppShell] handleActiveConsentData called with:', consentData);
    setCurrentConsentData(consentData);
  };

  console.log('[CommonAppShell] render', { currentConsentData, user });
  return (
    <AppShell
      padding={padding || "md"}
      style={{ background: "#f2f4fa" }}
      header={{ height: 60 }}
      {...(isSidebar && {
        navbar: {
          width: 300,
          breakpoint: "sm",
          collapsed: { mobile: !opened },
        }
      })}
    >
        <AppShell.Header>
          <AppHeader opened={opened} toggle={toggle} user={user} activeConsentData={handleActiveConsentData} />
        </AppShell.Header>
        {isSidebar && (
          <AppShell.Navbar>
            <AppSideBar name={t(`sidebar.${sidebarLabel}`)} />
          </AppShell.Navbar>
        )}
        <AppShell.Main>
          {React.cloneElement(children as React.ReactElement<any>, { currentConsentData, user })}
        </AppShell.Main>
    </AppShell>
  );
};

export default CommonAppShell;
